import {combineReducers} from 'redux';
import screenReducer from '../ducks/duck-screen';
import userReducer from '../ducks/duck-user';
import configReducer from '../ducks/duck-config';
import routerReducer from '../ducks/duck-router';
import gameReducer from '../ducks/duck-game';
import rankingReducer from '../ducks/duck-ranking';

const rootReducer = combineReducers({
	screenReducer,
	userReducer,
	configReducer,
	routerReducer,
	gameReducer,
	rankingReducer
});

export default rootReducer;
